/* PLOP_TEMPLATE_ROUTE_IMPORT */
import DisputesRoutes from "./viewsRoutes/Disputes";
import BulkUploadBonusesRoutes from "./viewsRoutes/BulkUploadBonuses";
import BulkUploadObTagsRoutes from "./viewsRoutes/BulkUploadObTags";
import BulkUploadEvInventoryRoutes from "./viewsRoutes/BulkUploadEvInventory";
import PoiRoutes from "./viewsRoutes/Poi";
import BulkModifyShelterRoutes from "./viewsRoutes/BulkModifyShelter";
import DriverNotificationRoutes from "./viewsRoutes/DriverNotification";
import DriverStoriesRoutes from "./viewsRoutes/DriverStories";
import DriverSheltersRoutes from "./viewsRoutes/DriverShelters";
import WalkerRoutes from "./viewsRoutes/Walker";
import CacheDashboardRoutes from "./viewsRoutes/CacheDashboard";
import BulkInventoryUploadRoutes from "./viewsRoutes/BulkInventoryUpload";
import BulkCouponCodeUploadRoutes from "./viewsRoutes/BulkCouponUpload";
import InventoriesRoutes from "./viewsRoutes/Inventories";
import OrderPayoutRoutes from "./viewsRoutes/OrderPayout";
import LifeLineRoutes from "./viewsRoutes/LifeLine";
import BulkUploadCarrierChangeManagerRoutes from "./viewsRoutes/BulkUploadCarrierChangeManager";
import FleetCoachBulkUploadRoutes from "./viewsRoutes/FleetCoachBulkUpload";
import FleetCoachRoutes from "./viewsRoutes/FleetCoach";
import PendingDeductionBulkUploadRoutes from "./viewsRoutes/PendingDeductionBulkUpload";
import PendingDeductionRoutes from "./viewsRoutes/PendingDeduction";
import GigsSupportRoutes from "./viewsRoutes/GigsSupport";
import SlotsRoutes from "./viewsRoutes/Slots";
import BoundariesRoutes from "./viewsRoutes/Boundaries";
import DriverSupportRoutes from "./viewsRoutes/DriverSupport";
import GroomingSelfiesRoutes from "./viewsRoutes/GroomingSelfies";
import DriverAssetIssuanceTrackingRoutes from "./viewsRoutes/DriverAssetIssuanceTracking";
import FeatureRoutes from "./viewsRoutes/Features";
import DriverTags from "./viewsRoutes/DriverTags";
import CountryRoutes from "./viewsRoutes/Country";
import CityRoutes from "./viewsRoutes/City";
import StateRoutes from "./viewsRoutes/State";
import DriverAssetsRoutes from "./viewsRoutes/DriverAssets";
import DriverMedalsRoutes from "./viewsRoutes/DriverMedals";
import LocalityRoutes from "./viewsRoutes/Locality";
import GenSettingRoutes from "./viewsRoutes/GenSetting";
import ConfigChangeLogRoutes from "./viewsRoutes/ConfigChangeLog";
import DriverAccountingRoutes from "./viewsRoutes/DriverAccounting";
import RolesRoutes from "./viewsRoutes/Roles";
import TripLocalityPropertyRoutes from "./viewsRoutes/TripLocalityProperty";
import DriverCashTransactionsRoutes from "./viewsRoutes/DriverCashTransactions";
import TelecallerRoutes from "./viewsRoutes/TeleCaller";
import TripStatisticsRoutes from "./viewsRoutes/TripStatistics";
import LeadsBulkUploadRoutes from "./viewsRoutes/LeadsBulkUpload";
import AssetsIssuanceRoutes from "./viewsRoutes/AssetsIssuance";
import DeliveryDriversRoutes from "./viewsRoutes/DeliveryDrivers";
import TdsAndRiderPayoutJobsRoutes from "./viewsRoutes/TdsAndRiderPayoutJobs";
import BulkUpdateTdsPropertiesRoutes from "./viewsRoutes/BulkUpdateTdsProperties";
import BulkUpdateRestrictedPayoutsRoutes from "./viewsRoutes/BulkUpdateRestrictedPayouts";
import BulkUpdatePayoutHoldRoutes from "./viewsRoutes/BulkUpdatePayoutHold";
import DlRcDetails from "./viewsRoutes/DlRcDetails";
import QcDetails from "./viewsRoutes/QcDetails";
import ObDetails from "./viewsRoutes/ObDetails";
import MerchantFacadeRoutes from "./viewsRoutes/MerchantFacade";
import DriverStoreMappingsRoutes from "./viewsRoutes/DriverStoreMappings";
import BlinkitOnboardingRoutes from "./viewsRoutes/BlinkitOnboarding";
import BulkRequestDriverInformationRoutes from "./viewsRoutes/BulkRequestDriverInformation";
import ChatDepartmentsRoutes from "./viewsRoutes/ChatDepartments";
import SubIssueTipsRoutes from "./viewsRoutes/SubIssueTips";
import SubIssueTypesRoutes from "./viewsRoutes/SubIssueTypes";
import IssueTypesRoutes from "./viewsRoutes/IssueTypes";
import DriverAppReleasesRoutes from "./viewsRoutes/DriverAppReleases";
import CallDepartments from "./viewsRoutes/CallDepartments";
import UserPropertyRoutes from "./viewsRoutes/UserProperty";
import DriverServiceMigration from "./viewsRoutes/DriverServiceMigration";
import FleetCoachDriverMappingRoutes from "./viewsRoutes/FleetCoachDriverMapping";
import RiderOffersRoutes from "./viewsRoutes/RiderOffers";
import PlatformFeeDetailsRoutes from "./viewsRoutes/PlatformFeeDetails";
import FleetCoachAppReleasesRoutes from "./viewsRoutes/FleetCoachAppReleases";
import OrdersRoutes from "./viewsRoutes/Orders";
import RainReportingRoutes from "./viewsRoutes/RainReporting";
import PrizeItemsRoutes from "./viewsRoutes/PrizeItems";
import DriverTdsCertificatesRoutes from "./viewsRoutes/DriverTdsCertificates";
import BulkUploadDriverSecondaryLocalityManagerRoutes from "./viewsRoutes/BulkUploadDriverSecondaryLocalityMapping";
import CampaignRoutes from "./viewsRoutes/Campaigns";
import FleetCoachTaskRoutes from "./viewsRoutes/FleetCoachTask.js";
import FeatureConfigRoutes from "./viewsRoutes/FeatureConfig";
import BulkUploadDriverPropertiesRoutes from "./viewsRoutes/BulkUploadDriverProperties";
import BulkUploadDriverReservationRoutes from "./viewsRoutes/BulkUploadDriverReservation";
import RestrictedPayoutDriversRoutes from "./viewsRoutes/RestrictedPayoutDrivers";
import CommunicationHubRoutes from "./viewsRoutes/CommunicationHub.js";
import DriverBannerRoutes from "./viewsRoutes/DriverBanner.js";
import QRGeneratorRoutes from "./viewsRoutes/QRGenerator.js";
import BulkUploadDriverPolygonIdManagerRoutes from "./viewsRoutes/BulkUploadDriverPolygonId";
import PolygonRoutes from "./viewsRoutes/Polygon.js";
import BulkCreatePolygonManagerRoutes from "./viewsRoutes/BulkCreatePolygon";
import BulkUpdatePolygonManagerRoutes from "./viewsRoutes/BulkUpdatePolygon";
import BulkUploadIncentiveMultipliersRoutes from "./viewsRoutes/BulkUploadIncentiveMultipliers";

export const privateRoutes = [
  /* PLOP_TEMPLATE_ROUTE_APPEND_ARR */
  ...DisputesRoutes,
  ...BulkUploadBonusesRoutes,
  ...BulkUploadObTagsRoutes,
  ...BulkUploadEvInventoryRoutes,
  ...PoiRoutes,
  ...BulkModifyShelterRoutes,
  ...DriverNotificationRoutes,
  ...DriverStoriesRoutes,
  ...FleetCoachAppReleasesRoutes,
  ...DriverSheltersRoutes,
  ...FleetCoachDriverMappingRoutes,
  ...WalkerRoutes,
  ...CacheDashboardRoutes,
  ...BulkInventoryUploadRoutes,
  ...BulkCouponCodeUploadRoutes,
  ...InventoriesRoutes,
  ...OrderPayoutRoutes,
  ...LifeLineRoutes,
  ...BulkUploadCarrierChangeManagerRoutes,
  ...BulkUploadDriverSecondaryLocalityManagerRoutes,
  ...BulkUploadDriverPolygonIdManagerRoutes,
  ...BulkCreatePolygonManagerRoutes,
  ...BulkUpdatePolygonManagerRoutes,
  ...FleetCoachBulkUploadRoutes,
  ...FleetCoachRoutes,
  ...PendingDeductionBulkUploadRoutes,
  ...PendingDeductionRoutes,
  ...GigsSupportRoutes,
  ...SlotsRoutes,
  ...BoundariesRoutes,
  ...DriverSupportRoutes,
  ...GroomingSelfiesRoutes,
  ...DriverAssetIssuanceTrackingRoutes,
  ...FeatureRoutes,
  ...DriverTags,
  ...CountryRoutes,
  ...CityRoutes,
  ...StateRoutes,
  ...DriverAssetsRoutes,
  ...DriverMedalsRoutes,
  ...LocalityRoutes,
  ...PolygonRoutes,
  ...GenSettingRoutes,
  ...RolesRoutes,
  ...TripLocalityPropertyRoutes,
  ...TelecallerRoutes,
  ...DriverAccountingRoutes,
  ...DriverCashTransactionsRoutes,
  ...TripStatisticsRoutes,
  ...AssetsIssuanceRoutes,
  ...LeadsBulkUploadRoutes,
  ...DeliveryDriversRoutes,
  ...TdsAndRiderPayoutJobsRoutes,
  ...BulkUpdateTdsPropertiesRoutes,
  ...BulkUpdateRestrictedPayoutsRoutes,
  ...BulkUpdatePayoutHoldRoutes,
  ...ConfigChangeLogRoutes,
  ...FeatureConfigRoutes,
  ...DlRcDetails,
  ...QcDetails,
  ...MerchantFacadeRoutes,
  ...CommunicationHubRoutes,
  ...DriverBannerRoutes,
  ...DriverStoreMappingsRoutes,
  ...BlinkitOnboardingRoutes,
  ...BulkRequestDriverInformationRoutes,
  ...ChatDepartmentsRoutes,
  ...OrdersRoutes,
  ...IssueTypesRoutes,
  ...SubIssueTipsRoutes,
  ...SubIssueTypesRoutes,
  ...DriverAppReleasesRoutes,
  ...CallDepartments,
  ...UserPropertyRoutes,
  ...DriverServiceMigration,
  ...RiderOffersRoutes,
  ...PlatformFeeDetailsRoutes,
  ...RainReportingRoutes,
  ...PrizeItemsRoutes,
  ...DriverTdsCertificatesRoutes,
  ...CampaignRoutes,
  ...FleetCoachTaskRoutes,
  ...BulkUploadDriverPropertiesRoutes,
  ...BulkUploadDriverReservationRoutes,
  ...RestrictedPayoutDriversRoutes,
  ...ObDetails,
  ...QRGeneratorRoutes,
  ...BulkUploadIncentiveMultipliersRoutes,
];
